export const FIRST_LOAD_OVERLAY_MS = 1000

export const FIRST_LOAD_OVERLAY_STYLE = {
  animation: 'none',
  opacity: 1,
} as const

export const waitAtLeast = async (
  startedAt: number,
  minMs: number,
): Promise<void> => {
  const remaining = minMs - (Date.now() - startedAt)
  if (remaining > 0) {
    await new Promise<void>((resolve) => {
      window.setTimeout(resolve, remaining)
    })
  }
}
